import { BORDER_COLORS as BC, TEXT_COLORS as TC } from '@constants/colors.ts';
import { DESKTOP_SIZES, SIZES } from '@constants/fonts.ts';
import styled from 'styled-components';

export const LocaleSwitcherWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
    width: 70px;
`;

export const LocaleSwitcherLabel = styled.label`
    ${DESKTOP_SIZES[SIZES.BODY_XS].fontSize};
    ${DESKTOP_SIZES[SIZES.BODY_XS].lineHeight};
    ${DESKTOP_SIZES[SIZES.BODY_XS].fontWeight};
    color: ${TC.body};
`;

export const LocaleSwitcherSelectWrapper = styled.div`
    .ant-select {
        width: auto;
        height: 36px;
    }
    .ant-select-selector {
        border-color: ${BC.disabled};
    }
`;
export const FlagLabel = styled.span`
    display: inline-flex;
    align-items: center;
    height: 100%;

    svg {
        height: 16px;
        width: auto;
        border-radius: 2px;
        box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15); /* keeps the white Japanese flag visible */
    }
`;
